import "../Services.css";
import Zoho from "../../Assets/Images/Zoho.png";
import ZohoFAQ from "./ZohoFAQ.js";

const App = () => {
  return (
    <section id="services" className="service-page">
      <div className="container">
        <div className="service-hero">
          <div className="hero-text">
            <h1>Zoho Books & Zoho Payroll: Implementation & Training</h1>
            <p className="hero-subtitle">End-to-end setup, migration, automation, and ongoing advisory support.</p>
          </div>
          <div className="hero-media">
            <img src={Zoho} alt="Zoho Advisory" className="desk-image" />
          </div>
        </div>
      </div>
      <ZohoFAQ />
    </section>
  );
};

export default App;